import React from 'react';
import './MenuButton.css';

export interface MenuButtonProps {
  onEditClick: () => void;
  onPlaceClick: () => void;
}

const MenuButton: React.FC<MenuButtonProps> = ({ onEditClick, onPlaceClick }) => {
  return (
    <div className="menu-buttons-container">
      <button className="menu-action-button edit-action" onClick={onEditClick}>
        <span className="material-symbols-outlined menu-action-icon">
          edit
        </span>
      </button>
      <button className="menu-action-button place-action" onClick={onPlaceClick}>
        <span className="material-symbols-outlined menu-action-icon">
          comedy_mask
        </span>
      </button>
    </div>
  );
};

export default MenuButton;

